module.exports = __webpack_public_path__ + "img/menu_77.c0ca3f29.png";